/*
 * The band whose button opens the assistant.
 *
 * Only loaded by a band configured that way. It waits for the widget before
 * doing anything, and if the widget never arrives the button is removed
 * rather than left sitting there doing nothing -- a band advertising an
 * assistant, with a button that ignores you, advertises the opposite.
 *
 * IT ASKS FOR THE WIDGET RATHER THAN WAITING FOR ONE. Polling window.AtomzChat
 * was the first shape, and nothing on a page assigns that global by itself --
 * the chat tile loads the SDK, and the chat tile is on search and collection
 * pages. This band is on the homepage. So it polled for nine seconds, found
 * nothing, removed its own button, and the section shipped with no call to
 * action on the one page it was written for.
 */
(function () {
  'use strict';

  function chat() {
    if (window.AtomzChatBoot) return window.AtomzChatBoot.ready();
    return Promise.reject(new Error('atomz-chat-boot.js is not on the page'));
  }

  function start() {
    var bands = document.querySelectorAll('[data-az-band-ask]');
    if (!bands.length) return;

    /*
     * Hidden first, shown when the widget answers. Removing it afterwards was
     * the first shape and it left a dead button on a marketing band for as
     * long as the wait ran: a band advertising an assistant, whose button
     * ignores you, advertises the opposite. The band's words stay either way,
     * because the offer is still true.
     */
    for (var k = 0; k < bands.length; k++) {
      var early = bands[k].querySelector('[data-az-band-cta]');
      if (early) early.hidden = true;
    }

    chat().then(function (c) {
      for (var i = 0; i < bands.length; i++) {
        (function (band) {
          var btn = band.querySelector('[data-az-band-cta]');
          if (!btn) return;
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var seed = band.getAttribute('data-az-band-ask') || '';
            c.open(seed || undefined);
          });
        })(bands[i]);
      }
    }).catch(function () {
      for (var j = 0; j < bands.length; j++) {
        var b = bands[j].querySelector('[data-az-band-cta]');
        if (b && b.parentNode) b.parentNode.removeChild(b);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
